import { buildUser, isAllowedTimeZonePreference } from '../domain/model/User';
import { TenancyRuleViolation } from '../domain/TenancyRuleViolation';

/**
 * Whose zone it is. Which zone a rule uses is the consuming context's decision, made at its edge and
 * passed down as an argument; this only answers what the user's zone is.
 */

/**
 * The zone a user reads and enters dates in: their preference, or the device's when they have none.
 *
 * Takes the account record as the store holds it, so this file is the one that knows the field's
 * name. The device zone comes from the caller, because reading the device is the edge's business.
 *
 * @param {{userId?: string, timeZonePreference?: *}|null|undefined} account
 * @param {string} deviceZone - IANA zone of the device in use
 * @returns {string}
 */
export const userTimeZone = (account, deviceZone) => buildUser({
  userId: account?.userId ?? null,
  timeZonePreference: account?.timeZonePreference ?? null,
}).timeZonePreference ?? deviceZone;

/**
 * @param {{saveTimeZonePreference: (userId: string, zone: string|null) => Promise<void>}} users
 * @returns {(userId: string, zone: string|null) => Promise<void>}
 */
export const changeTimeZonePreference = (users) => async (userId, zone) => {
  if (!isAllowedTimeZonePreference(zone)) {
    throw new TenancyRuleViolation(`Not a time zone: ${zone}`);
  }
  await users.saveTimeZonePreference(userId, zone);
};
